import React from "react";
import Seo from "cube-components/Seo";
import MenuNotFound from "cube-components/MenuNotFound";
import PageLayout from "cube-components/PageLayout";

const meta = {
  title: "Not found",
  description: "This page does not exist",
  robots: "noindex,nofollow"
};

const NotFound404 = () => {
  return (
    <PageLayout>
      {/* <Layout lang="en" title="Not found" subtitle="This page does not exist"> */}
      <section className="relative">
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
          <div className="pt-32 md:pt-40">
            {/* Hero content */}
            <div className="max-w-3xl mx-auto text-left">
              <h1 className="h1 font-hkgrotesk mb-6">
                Not Found
              </h1>
              <p className="text-xl text-lucid-300 mb-10">
                This page does not exist
              </p>
              <p className="text-md text-lucid-300 mb-5 font-bold">Go back to another page:</p>
              <MenuNotFound lang="en" />
            </div>
          </div>
        </div>
      </section>

    </PageLayout>
  );
};

export default NotFound404;

export const Head = () =>
  <Seo lang="en"
       meta={meta}
  />;
